import './Details.scss';

import DetailsHeader from "./components/DetailsHeader/DetailsHeader";
import DetailsContent from "./components/DetailsContent/DetailsContent";

const Details = ({id}) => {

    return (
        <div className={"details"}>
            <div className={"details_container"}>
                <div className={"details_header"}>
                    <DetailsHeader id={id}/>
                </div>
                <div className={"details_content"}>
                    <DetailsContent id={id}/>
                </div>
            </div>
        </div>
    )
}

export default Details;